/** Compact asset classes for the broker's currently tradeable instrument universe. */
export const SYMBOL_CATEGORY_ORDER = ["Forex", "Crypto", "Commodities", "Indices", "Stocks", "Other"];
export const SYMBOL_CATEGORY_OVERRIDES = {
  EURUSD: "Forex", GBPUSD: "Forex", USDJPY: "Forex", BTCUSD: "Crypto", ETHUSD: "Crypto",
  AAPL: "Stocks", MSFT: "Stocks", SPY: "Stocks",
};
const FOREX_CURRENCY_CODES = ["USD", "EUR", "GBP", "JPY", "CHF", "AUD", "CAD", "NZD", "CNH", "SEK", "NOK", "MXN", "SGD", "HKD", "TRY", "ZAR", "DKK", "PLN", "HUF", "CZK", "THB", "ILS", "RUB", "CNY"];
const CRYPTO_SYMBOL_PREFIXES = ["BTC", "ETH", "XRP", "LTC", "SOL", "ADA", "DOGE", "BNB", "DOT", "AVAX", "MATIC", "LINK", "BCH", "XLM", "TRX", "ATOM", "UNI", "FIL", "ETC"];
const COMMODITY_SYMBOL_PREFIXES = ["XAU", "XAG", "XPT", "XPD", "OIL", "UKOIL", "USOIL", "NGAS"];
const INDEX_SYMBOLS = new Set(["SPX", "NDX", "DJI", "US30", "US100", "US500", "NAS100", "UK100", "GER40", "JPN225", "AUS200", "CHINA50", "FRA40", "ESP35", "ITA40", "HK50", "EU50", "STOXX50"]);

export function categorizeSymbol(symbol) {
  const sym = String(symbol || "").toUpperCase();
  if (SYMBOL_CATEGORY_OVERRIDES[sym]) return SYMBOL_CATEGORY_OVERRIDES[sym];
  if (sym.length === 6 && FOREX_CURRENCY_CODES.includes(sym.slice(0, 3)) && FOREX_CURRENCY_CODES.includes(sym.slice(3, 6))) return "Forex";
  if (CRYPTO_SYMBOL_PREFIXES.some((prefix) => sym.startsWith(prefix)) || /^(BTC|ETH|XRP|LTC|SOL|ADA|DOGE|BNB|DOT|AVAX|LINK)[-_]/.test(sym)) return "Crypto";
  if (COMMODITY_SYMBOL_PREFIXES.some((prefix) => sym.startsWith(prefix))) return "Commodities";
  if (INDEX_SYMBOLS.has(sym) || /^(US|UK|GER|JPN|AUS|FRA|ESP|ITA|HK|EU|CHINA|NAS|SPX|NDX|DJI)[0-9]/.test(sym)) return "Indices";
  // cTrader instruments commonly use TICKER.EXCHANGE; plain ticker symbols are equities too.
  if (/^[A-Z0-9]+\.[A-Z]+$/.test(sym) || /^[A-Z]{1,5}$/.test(sym)) return "Stocks";
  return "Other";
}

export function groupSymbols(symbols, query = "", cap = Infinity) {
  const q = String(query || "").trim().toUpperCase();
  const groups = new Map();
  for (const item of symbols || []) {
    const symbol = String(item || "").toUpperCase();
    if (q && !symbol.includes(q)) continue;
    const category = categorizeSymbol(symbol);
    if (!groups.has(category)) groups.set(category, []);
    groups.get(category).push(symbol);
  }
  return SYMBOL_CATEGORY_ORDER.map((category) => {
    const all = (groups.get(category) || []).sort((a, b) => a.localeCompare(b));
    return { category, symbols: all.slice(0, cap), count: all.length, moreCount: Math.max(0, all.length - cap) };
  }).filter((group) => group.count > 0);
}
